import {createRouter, createWebHistory} from 'vue-router'
import DefaultLayout from "@/layouts/DefaultLayout";
import Index from '../pages/IndexPage.vue'
import Transfer from '@/pages/TransferPage.vue';
import Messages from '@/pages/MessagesPage.vue';
import ForYou from '@/pages/ForYouPage.vue';
import ViewPage from '@/pages/ViewPage.vue';
import CurrencyExchange from '@/pages/CurrencyExchange.vue';
import LoginPage from '@/pages/LoginPage.vue';
import ContactUs from '@/pages/ContactUs.vue';
import PersonalSetup from "@/pages/PersonalSetup";
import ChangePassword from '@/components/setting/ChangePassword.vue';
import ActivityLog from '@/components/setting/ActivityLog.vue';
import CustomAccount from '@/components/setting/CustomAccount.vue';
import FrequentBeneficiary from '@/components/setting/FrequentBeneficiary.vue';
import PayPage from '@/pages/PayPage.vue';
import PayServices from '@/components/payment/PayServices.vue';
import PayState from '@/components/payment/PayState.vue';

const routes = [
    {
        path: '/', component: DefaultLayout, children: [
            {path: '', name: 'Index', component: Index},
            {path: '/transfer', name: 'Transfer', component: Transfer},
            {path: '/messages', name: 'Messages', component: Messages, meta: {title: 'Messages'}},
            {path: '/operations', name: 'Operations', component: ForYou},
            {path: '/view/balance', name: 'ViewPage', component: ViewPage},
            {path: '/currency', name: 'Currency', component: CurrencyExchange},
            {path: '/contact-us', name: 'ContactUs', component: ContactUs, meta: {title: 'Contact Us'}},
            {path: '/pay', name: 'Payment', component: PayPage, children: [
                    {
                        path: 'services',
                        component: PayServices
                    },
                    {
                        path: 'state',
                        component: PayState
                    },
                ] },

            {
                path: '/setting', name: 'PersonalSetup', component: PersonalSetup, children: [
                    {
                        path: 'change-password',
                        component: ChangePassword
                    },
                    {
                        path: 'activity-log',
                        component: ActivityLog
                    },
                    {
                        path: 'custom-account',
                        component: CustomAccount
                    },
                    {
                        path: 'beneficiaries',
                        component: FrequentBeneficiary
                    }
                ]
            },
        ],
    },
    {path: '/login', name: 'LoginPage', component: LoginPage}

]

const router = createRouter({
    history: createWebHistory(),
    routes,
})


router.beforeEach((to, from, next) => {
    const publicPages = ['/login']   // مسیرهایی که نیاز به auth ندارند
    const authRequired = !publicPages.includes(to.path)
    const token = localStorage.getItem('token')

    if (authRequired && !token) {
        return next('/login') // هدایت به صفحه لاگین
    }

    next() // ادامه مسیر
})

export default router
